import {
  LOAD_TKN_INFO,
  SET_USER_INFO,
  LOGOUT,
  CHANGE_TAB,
  SET_USER_SUBS,
} from '../constants/action-types/auth';
import { initialState } from '../store/models/auth';

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_TKN_INFO:
      return {
        ...state,
        idToken: action.idToken,
        accessToken: action.accessToken,
        profile: action.profile,
      };
    case SET_USER_INFO:
      return { ...state, userinfo: action.userinfo };
    case SET_USER_SUBS:
      return { ...state, subscriptions: action.subscriptions };
    case LOGOUT:
      return { ...state, ...initialState };
    case CHANGE_TAB:
      return { ...state, tab: action.tab };
    default:
      return state;
  }
};

export default authReducer;
